/**
 * Counter-offer earnest money — shared by both counter surfaces
 * (`CounterOfferModal` and the workspace's inline `CounterOfferForm`).
 *
 * QA D1 / run-6 N15: a seller countered "285 with 8k earnest", the buyer
 * accepted, and the executed agreement still said $5,000 — the counter had no
 * deposit field and the API dropped the amount. A counter now carries the
 * deposit; left blank, the server keeps the one already on the table.
 */

/**
 * The form's starting value: the deposit on the table, or blank for none.
 *
 * @param {number|string|null|undefined} earnest
 * @returns {string}
 */
export function initialCounterEarnest(earnest) {
  const n = Number(earnest);
  return earnest !== null && earnest !== undefined && Number.isFinite(n) && n > 0
    ? String(Math.round(n))
    : '';
}

/**
 * Why the entered deposit can't be sent, or null when it can (blank is fine:
 * it keeps the current deposit). Mirrors the server: more than $0 and no more
 * than the offer price.
 *
 * @param {number|string} earnest - Entered amount ('' when blank).
 * @param {number|string} offerPrice - The counter's price.
 * @returns {string|null}
 */
export function counterEarnestError(earnest, offerPrice) {
  if (earnest === '' || earnest === null || earnest === undefined) return null;
  const n = Number(earnest);
  if (!Number.isFinite(n) || n <= 0) return 'Earnest money must be more than $0.';
  const price = Number(offerPrice);
  if (Number.isFinite(price) && price > 0 && n > price) {
    return "Earnest money can't be more than the offer price.";
  }
  return null;
}

/**
 * The `earnest_money` part of the counter payload: the amount when entered,
 * nothing when blank (the server keeps the deposit on the table).
 *
 * @param {number|string} earnest
 * @returns {{earnest_money?: number}}
 */
export function counterEarnestPayload(earnest) {
  return earnest === '' || earnest === null || earnest === undefined
    ? {}
    : { earnest_money: Number(earnest) };
}
